import script from "./CollapsibleContainer.vue?vue&type=script&setup=true&lang=ts"
export * from "./CollapsibleContainer.vue?vue&type=script&setup=true&lang=ts"

import "./CollapsibleContainer.vue?vue&type=style&index=0&id=206046b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-206046b6"]])

export default __exports__